export enum EStudyField {
  SCIENCES = 'SCIENCES',
  SOCIALS = 'SOCIALS',
  HUMANITIES = 'HUMANITIES',
  ARTS = 'ARTS'
}
